import { Instance } from 'mobx-state-tree';
import { DriverEditedDtoModelBase } from './DriverEditedDtoModel.base';

/* The TypeScript type of an instance of DriverEditedDtoModel */
export interface DriverEditedDtoModelType extends Instance<typeof DriverEditedDtoModel.Type> {}

/* A graphql query fragment builders for DriverEditedDtoModel */
export { selectFromDriverEditedDto, driverEditedDtoModelPrimitives, DriverEditedDtoModelSelector } from './DriverEditedDtoModel.base';

/**
 * DriverEditedDtoModel
 */
export const DriverEditedDtoModel = DriverEditedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
